import {
  getInsuranceProduct,
  isCancellationDateEligible,
  isInsuranceEligibleForCancellation,
  cancelInsurance,
} from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';
import { CancelInsuranceFormFetchPolicyResponse, CancelInsuranceResponse } from '@/interfaces';

export const CancelInsuranceFormService = {
  /**
   * Validate Cancellation Reasons
   * @param policyNumber
   * @param payload
   * @returns
   */
  isInsuranceEligibleForCancellation(
    policyNumber: string,
    payload: object
  ): Promise<{ jpCode: string; isEligible: boolean }> {
    return _http.HttpPost(isInsuranceEligibleForCancellation.replace('{0}', policyNumber), payload);
  },

  /**
   * Validate Cancellation Date
   * @param policyNumber
   * @param payload
   * @returns
   */
  isCancellationDateEligible(payload: object): Promise<{ jpCode: string; isEligible: boolean }> {
    return _http.HttpPost(isCancellationDateEligible, payload);
  },

  /**
   * Fetch Policy
   * @param policyNumber
   * @returns
   */
  fetchPolicy(policyNumber: string): Promise<CancelInsuranceFormFetchPolicyResponse> {
    return _http.HttpGet(getInsuranceProduct.replace('{0}', policyNumber));
  },

  /**
   * Cancel Policy
   * @param model
   * @returns
   */
  cancelInsurance(model: object): Promise<CancelInsuranceResponse> {
    return _http.HttpPost(cancelInsurance, model);
  },
} as const;
